import {IRoute} from './route.interface';
import {RouteData, RouteDefinition, RouteParams} from '../../routing-configuration/route-definition/route-definition';
import React from 'react';

export abstract class RouteBase implements IRoute {
  constructor(private _routeDefinition: RouteDefinition, private _routeParams: RouteParams) {}

  render(): React.ReactNode {
    return this._routeDefinition?.render(this._routeParams);
  }

  get routeParams(): RouteParams {
    return this._routeParams;
  }

  get isOrbitRoute(): boolean {
    return this._isOrbitRoute();
  }

  get data(): RouteData {
    return this._routeDefinition.data;
  }

  get routeDefinition(): RouteDefinition {
    return this._routeDefinition;
  }


  protected abstract _isOrbitRoute(): boolean;

}
